export default __webpack_public_path__ + "static/media/settingsIcon.b825c974.svg";